import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { CanDeactivateGuard, CanDeactivateGuardCustom } from "features";
import { NotFoundComponent } from "@featuresAY/not-found/components/not-found/not-found.component";
import { DisconnectPageComponent } from "@featuresAY/disconnect/components/disconnect-page/disconnect-page.component";
import { AppRoutesEnum, VersionRouteEnum } from "@core/layout/enums/layout-routes.enum";

const defaultRoute = `${AppRoutesEnum.APP}/${VersionRouteEnum.V1}`;

const routes: Routes = [
	{
		path: AppRoutesEnum.MENU,
		loadChildren: () => import("@featuresAY/menu/menu.module").then((m) => m.MenuModule),
	},
	{
		path: AppRoutesEnum.SIGNIN_AY,
		loadChildren: () => import("@featuresAY/signin-ay/signin-ay.module").then((m) => m.SigninAyModule),
	},
	{
		path: AppRoutesEnum.APP,
		loadChildren: () => import("./core/layout/routes/layout.routes").then((r) => r.LAYOUT_ROUTES),
	},
	{ path: AppRoutesEnum.LOGOUT, component: DisconnectPageComponent },
	{ path: "", redirectTo: defaultRoute, pathMatch: "full" },
	// { path: 'getSessionsFromSsoToken', component: SessionsComponent },
	{
		path: "error-404",
		component: NotFoundComponent,
	},
	{ path: "**", redirectTo: "error-404" },
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule],
	providers: [CanDeactivateGuard, CanDeactivateGuardCustom],
})
export class AppAyRoutingModule {}
